import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  id?: string;
  className?: string;
  size?: 'sm' | 'md';
  indeterminate?: boolean;
}

export default function Checkbox({
  checked,
  onChange,
  id,
  className = '',
  size = 'md',
  indeterminate = false,
}: CheckboxProps) {
  const sizeClasses = size === 'sm'
    ? 'w-3.5 h-3.5 rounded-[5px]'
    : 'w-[18px] h-[18px] rounded-md';

  const iconSize = size === 'sm' ? 10 : 12;

  return (
    <button
      type="button"
      id={id}
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      onClick={() => onChange?.(!checked)}
      className={
        `shrink-0 inline-flex items-center justify-center cursor-pointer transition-all duration-150 border checkbox-btn ${sizeClasses} ${className} `
      }
      data-checked={(checked || indeterminate).toString()}
      style={{
        background: checked || indeterminate ? 'var(--accent)' : 'var(--bg-input)',
      }}
    >
      {(checked || indeterminate) && (
        <Check size={iconSize} strokeWidth={2.5} style={{ color: 'var(--text-inverse)' }} />
      )}
    </button>
  );
}

/* Label wrapper for checkbox + text */
export function CheckboxLabel({
  checked,
  onChange,
  label,
  description,
  className = '',
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer group ${className}`}>
      <div className="pt-0.5 shrink-0">
        <Checkbox checked={checked} onChange={onChange} />
      </div>
      <div className="min-w-0">
        <p
          className="text-sm font-medium transition-colors"
          style={{ color: 'var(--text-secondary)' }}
        >
          {label}
        </p>
        {description && (
          <p className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
            {description}
          </p>
        )}
      </div>
    </label>
  );
}